import { useQuery } from "@tanstack/react-query";
import { getInvestmentNotes } from "./investNowApis";

export const InvestNowQueryKeys = {
    GET_INVESTMENT_NOTES: 'getInvestmentNotes',
}

export const useInvestmentNotesQuery = (page = 1, params = {}) => {
    return useQuery({
        queryKey: [InvestNowQueryKeys.GET_INVESTMENT_NOTES, page, params],
        queryFn: async () => {
            const response = await getInvestmentNotes(page, params);
            return response.data;
        },
        staleTime: 5 * 60 * 1000,
        cacheTime: 10 * 60 * 1000,
        keepPreviousData: true,
    });
};